import Md5Worker from "./getMd5Worker.worker";

function getMd5(file, fileId, chunkSize) {
  return new Promise((resolve, reject) => {
    if (window.Worker) {
      const worker = new Md5Worker();
      worker.postMessage([file, fileId, chunkSize]);
      worker.onmessage = (ev) => {
        console.log(`收到了来自web worker的消息:${JSON.stringify(ev.data)}`);
        const md5Data = ev.data.md5;
        const fileId = ev.data.fileId;
        if (md5Data && fileId) {
          resolve({ md5: md5Data, fileId });
          worker.terminate();
        }
      };
      worker.onerror = (error) => {
        reject(error);
      };
      window.addEventListener("beforeunload", () => {
        worker.terminate();
      });
    } else {
      reject("当前浏览器不支持，请升级或更换浏览器。");
    }
  });
}

export default getMd5;



// WEBPACK FOOTER //
// ./src/lego/getMd5/index.js